export default "__VITE_ASSET__Crvg3Gqj__"